<template>

  <div class="relative min-h-screen flex flex-col justify-between">


    <div class="absolute inset-0 bg-cover bg-center"
      :style="{ backgroundImage: 'url(' + require('@/assets/background.png') + ')' }">
    </div>

    <div class="relative z-10 flex flex-1 items-center justify-center p-6">
      <div class="bg-gray-50 shadow-lg rounded-lg p-8 max-w-md w-full">

        <h2 class="text-2xl font-semibold text-center mb-6">LOGIN</h2>

        <Form @submit="onSubmit" :validation-schema="schema">

          <div class="mb-4">
            <label class="block text-gray-600 text-sm font-semibold mb-2">Mail</label>
            <Field name="mail" v-slot="{ field, errors }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" placeholder="Mail" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="mail" />
              </span>
            </Field>
          </div>

          <div class="mb-4">
            <label class="block text-gray-600 text-sm font-semibold mb-2">Contraseña</label>
            <Field name="password" v-slot="{ field, errors }" v-model="formData.password">
              <InputText v-bind="field" type="password" placeholder="Contraseña" class="input-base"
                :class="{ 'bg-gray-50': errors.length === 0, 'input-success': errors.length === 0 && field.value !== '', 'input-error': errors.length > 0 }" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="password" />
              </span>
            </Field>
          </div>

          <button type="submit" label="REGISTRARME"
            class="mt-4 w-full px-4 py-2 bg-black border-black text-white hover:bg-transparent font-semibold hover:text-black border rounded-lg"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>INGRESAR
          </button>

          <BlockUI :blocked="isSubmitting" fullScreen />

        </Form>

      </div>
    </div>

  </div>

  <footer class="w-full py-5 bg-black flex flex-row items-center justify-center text-white font-semibold text-sm">
    © 2025 Desarrollado por <a href="https://qreventos.com" target="qreventos">&nbsp;QREventos</a>
  </footer>

</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import BlockUI from 'primevue/blockui';

import seguridadService from '@/services/seguridad.services';
import { UsuarioEmpresa } from 'qreventos-suite/src/services/suite.interfaces';

export default defineComponent({
  components: {
    InputText, BlockUI,
    Field, ErrorMessage, Form
  },
  created() {
    document.title = "Empresas - Login";
  },
  data() {
    return {
      isSubmitting: false,
      formData: {
        mail: '',
        password: ''
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        mail: yup.string().required('Ingresá tu correo').email('Correo inválido'),
        password: yup.string().required('Ingresá tu contraseña'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      try {
        const usuarioEmpresa: UsuarioEmpresa = await seguridadService.login(this.formData.mail, this.formData.password);
        if (usuarioEmpresa) {

          if (!usuarioEmpresa.activo) {
            Swal.fire({ title: "Error", text: "El usuario fue deshabilitado", icon: "error" });
            return;
          }

          this.$router.push({ path: '/invitaciones' });
        }

      } catch (error) {
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
        this.formData.password = '';
      } finally {
        this.isSubmitting = false;
      }
    }
  },
  async mounted() {
  }
});
</script>
